module.exports = __webpack_public_path__ + "img/email.5223a646.svg";